import {useEffect, useState} from "react";
import {useForm, Controller} from "react-hook-form";
import {Button, Loading } from "~/components";
import {
    TextAreaField,
} from "~/components/Forms";
import {List, notification} from "antd";
import {apiError, handleRequest} from "../../../../utils";
import {contractApi} from "../../../../api";

function ContractFormNote({item}) {

    const [itemsNote, setItemsNote] = useState([])

    const initialValues = {
        note: '',
    }

    const { control, handleSubmit, formState: { isSubmitting, errors }, reset } = useForm({
        defaultValues: initialValues,
    });

    const loadNote = async () => {

        if (!item?.id)
        {
            notification.error({
                message: 'Lỗi',
                description: 'Không có thông tin hợp đồng lấy ghi chú'
            });
            return;
        }

        let [error, response] = await handleRequest(contractApi.note(item.id));

        let message = apiError(`Lấy ghi chú của hợp đồng thất bại`, error, response);

        if (!message) {
            setItemsNote(response.data)
        }
    }

    const handleSaveNote = async (data, item) => {
        if (!item?.id) {
            notification.error({message: 'Lỗi', description: 'Không có thông tin hợp đồng để cập nhật'});
            return;
        }
        data.id = item.id;
        let [error, response] = await handleRequest(contractApi.addNote(data));
        let message = apiError(`Cập nhật thông tin hợp đồng thất bại`, error, response);
        if(!message) {
            setItemsNote([
                ...itemsNote,
                response.data
            ])
        }
    }

    useEffect(() => {
        if (item?.id) {
            loadNote();
            reset(initialValues)
        }
    }, [item]);

    const onSubmit = async (data) => {
        await handleSaveNote(data, item);
    }

    return (
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
            {isSubmitting && <Loading/>}
            {itemsNote && <List
                itemLayout="horizontal"
                dataSource={itemsNote}
                renderItem={(item, index) => (
                    <List.Item>
                        <List.Item.Meta
                            title={item.name}
                            description={item.note}
                        />
                    </List.Item>
                )}
            />}
            <br />
            <Controller control={control} name="note" render={({ field }) => (
                <TextAreaField placeholder="Ghi chú"  errors={errors} {...field} />
            )}/>
            <div className="form-group d-flex justify-content_end mt-2">
                <Button primary type="submit">Thêm ghi chú</Button>
            </div>
        </form>
    )
}

export default ContractFormNote;